import React, { useState, useCallback, useEffect } from "react";
import {
  Form,
  Card,
  Button,
  Row,
  Col,
  Container,
  Modal,
} from "react-bootstrap";
import { useParams, useNavigate } from "react-router-dom";
import debounce from "lodash/debounce";
import Select from "react-select/async";
import {
  getRoomTypesList,
  addRoom,
  updateRoom,
} from "../../../services/OrganisationServices/hostelRoomServices";
import {
  callToast,
  prepareSiteList,
  showErrorMessages,
} from "../../../../src/services/utilityFunctions.js";
import { useGlobalState } from "../../../services/hostelConst";

const RoomManagementForm = ({ navigate, refresh }) => {
  const { openModal, closeModal, modalState } = useGlobalState();
  const masterData = modalState.data;
  console.log("modal state data is: ", modalState);
  const hostelId = modalState.hostId;
  console.log("the hostelId is: ", hostelId);
  const [formData, setFormData] = useState({
    hostelId,
    roomNumber: "",
    typeId: null,
    roomId: null,
  });

  const [selectedRoomType, setSelectedRoomType] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [modalConfig, setModalConfig] = useState({
    title: "",
    message: "",
    type: "success",
  });
  const fetchRoomTypeDetails = async (typeId) => {
    try {
      const response = await getRoomTypesList({
        hostelId,
        pageNum: 1,
        query: "",
      });

      if (response.status === "success") {
        const entityList =
          response.data.entityList || response.data.response?.entityList;
        if (entityList && Array.isArray(entityList)) {
          const roomType = entityList.find((type) => type._ID === typeId);
          if (roomType) {
            console.log("room type is: ", roomType);
            setSelectedRoomType({
              label: roomType.name || roomType.NAME,
              value: roomType._ID,
              price: roomType.price || roomType.PRICE,
              isAc: roomType.isAC || roomType.AC,
              bed:   roomType.BED,
              description: roomType.description || roomType.DESCRIPTION,
            });
          }
        }
      }
    } catch (error) {
      console.error("Error fetching room type details:", error);
      const myButton = document.getElementById("myToastButton");
      callToast("error", "Error", "Failed to load room type details", myButton);
    }
  };

  useEffect(() => {
    if (masterData) {
      setFormData({
        hostelId,
        roomNumber: masterData["ROOM NUMBER"],
        typeId: masterData._TYPE,
        roomId: masterData._ID,
      });
      if (masterData._TYPE) {
        fetchRoomTypeDetails(masterData._TYPE);
      }
    }
  }, [masterData, hostelId]);

  const loadRoomTypes = useCallback(
    debounce(async (inputValue, callback) => {
      try {
        const response = await getRoomTypesList({
          hostelId,
          pageNum: 1,
          query: inputValue,
        });

        if (response.status === "success") {
          const entityList =
            response.data.entityList || response.data.response?.entityList;
            console.log("data is: ", entityList);
          if (entityList && Array.isArray(entityList)) {
            const options = entityList.map((type) => ({
              label: type.name || type.NAME,
              value: type._ID,
              price: type.price || type.PRICE,
              isAc: type.isAC || type.AC,
              bed:   type.BED,
              description: type.description || type.DESCRIPTION,
            }));
            callback(options);
            return;
          }
        } else if (response.status === "fail") {
          showErrorMessages({ data: response.data, navigate });
          const myButton = document.getElementById("myToastButton");
          callToast("error", "Error", "Failed to load room types", myButton);
          callback([]);
        }
        callback([]);
      } catch (error) {
        console.error("Error loading room types:", error);
        showErrorMessages({
          data: {
            message: "Failed to load room types",
            errors: error.message,
          },
          navigate,
        });
        const myButton = document.getElementById("myToastButton");
        callToast("error", "Error", "An unexpected error occurred", myButton);
        callback([]);
      }
    }, 300),
    [hostelId, navigate]
  );

  const handleModal = (title, message, type = "success") => {
    setModalConfig({ title, message, type });
    setShowModal(true);

    setTimeout(() => {
      setShowModal(false);
      if (type === "success") {
        // closeModal();
      }
    }, 2000);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setIsLoading(true);
    try {
      console.log("form data is : ", formData);
      const response = masterData
        ? await updateRoom({ ...formData, roomId: formData.roomId })
        : await addRoom(formData);

      if (response.status === "success") {
        const myButton = document.getElementById("myToastButton");
        callToast(
          "success",
          "Success",
          `Room ${masterData ? "updated" : "added"} successfully!`,
          myButton
        );

        await refresh?.({ columnRefresh: false, isLoading: false });

        if (!masterData) {
          setFormData({ hostelId, roomNumber: "", typeId: null, roomId: null });
          setSelectedRoomType(null);
        }
        closeModal();
      } else if (response.status === "fail") {
        showErrorMessages({ data: response.data, navigate });
        const myButton = document.getElementById("myToastButton");
        callToast(
          "error",
          "Error",
          response.message || `Failed to ${masterData ? "update" : "add"} room`,
          myButton
        );
      }
    } catch (error) {
      showErrorMessages({
        data: {
          message: `Failed to ${masterData ? "update" : "add"} room`,
          errors: error.message,
        },
        navigate,
      });
      const myButton = document.getElementById("myToastButton");
      callToast("error", "Error", "An unexpected error occurred", myButton);
    } finally {
      setIsLoading(false);
    }
  };

  const handleReset = () => {
    if (masterData) {
      setFormData({
        hostelId,
        roomNumber: masterData.roomNumber,
        typeId: masterData.typeId,
        roomId: masterData._id,
      });
      setSelectedRoomType({
        label: masterData.roomType.name,
        value: masterData.typeId,
        price: masterData.roomType.price,
        isAc: masterData.roomType.isAc,
        bed: masterData.roomType.bed,
        description: masterData.roomType.description,
      });
    } else {
      setFormData({ hostelId, roomNumber: "", typeId: null, roomId: null });
      setSelectedRoomType(null);
    }
  };
  const validateForm = () => {
    const newErrors = {};
    if (!formData.roomNumber?.trim()) {
      newErrors.roomNumber = "Room number is required";
    }
    if (!formData.typeId) {
      newErrors.typeId = "Room type is required";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  return (
    <Container fluid className="p-0">
      <Card className="shadow-sm">
        <Card.Body className="px-4 py-4">
          <Form onSubmit={handleSubmit}>
            <Row className="mb-4">
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Room Number</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter room number"
                    value={formData.roomNumber}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        roomNumber: e.target.value,
                      }))
                    }
                    isInvalid={!!errors.roomNumber}
                    style={{ maxWidth: "300px" }}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.roomNumber}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Room Type</Form.Label>
                  <Select
                    cacheOptions
                    defaultOptions
                    value={selectedRoomType}
                    loadOptions={loadRoomTypes}
                    onChange={(selected) => {
                      setSelectedRoomType(selected);
                      setFormData((prev) => ({
                        ...prev,
                        typeId: selected?.value || null,
                      }));
                    }}
                    isSearchable
                    placeholder="Search room type..."
                    className={errors.typeId ? "is-invalid" : ""}
                    styles={{
                      control: (base) => ({
                        ...base,
                        maxWidth: "300px",
                      }),
                    }}
                  />
                  {errors.typeId && (
                    <div className="invalid-feedback d-block">
                      {errors.typeId}
                    </div>
                  )}
                </Form.Group>
              </Col>
            </Row>

            <Card className="bg-light border-0 mb-4">
              <Card.Body>
                <h6 className="text-primary mb-3">Room Details</h6>
                <Row className="g-3">
                  <Col md={4}>
                    <div className="d-flex align-items-center">
                      <span className="text-muted me-2">Cost:</span>
                      <strong>
                        {selectedRoomType ? (
                          `₹${selectedRoomType.price}`
                        ) : (
                          <span className="text-muted">
                            Select room type...
                          </span>
                        )}
                      </strong>
                    </div>
                  </Col>
                  <Col md={4}>
                    <div className="d-flex align-items-center">
                      <span className="text-muted me-2">AC:</span>
                      <strong>
                        {selectedRoomType ? (
                          selectedRoomType.isAc === "Y" ? (
                            "Yes"
                          ) : (
                            "No"
                          )
                        ) : (
                          <span className="text-muted">
                            Select room type...
                          </span>
                        )}
                      </strong>
                    </div>
                  </Col>
                  <Col md={4}>
                    <div className="d-flex align-items-center">
                      <span className="text-muted me-2">Beds:</span>
                      <strong>
                        {selectedRoomType ? (
                          selectedRoomType.bed
                        ) : (
                          <span className="text-muted">
                            Select room type...
                          </span>
                        )}
                      </strong>
                    </div>
                  </Col>
                  <Col xs={12} className="mt-3">
                    <span className="text-muted">Description:</span>
                    <p className="mb-0 mt-2">
                      {selectedRoomType ? (
                        selectedRoomType.description ||
                        "No description available"
                      ) : (
                        <span className="text-muted">
                          Select room type to view description...
                        </span>
                      )}
                    </p>
                  </Col>
                </Row>
              </Card.Body>
            </Card>

            <div className="d-flex justify-content-end gap-2">
              <Button
                variant="outline-secondary"
                onClick={handleReset}
                disabled={isLoading}
              >
                Reset
              </Button>
              <Button variant="primary" type="submit" disabled={isLoading}>
                {isLoading
                  ? masterData
                    ? "Updating..."
                    : "Adding..."
                  : masterData
                  ? "Update Room"
                  : "Add Room"}
              </Button>
            </div>
          </Form>
        </Card.Body>
      </Card>
      <Modal show={showModal} backdrop="static" keyboard={false}>
        <Modal.Body className="text-center py-4">
          <h5>{modalConfig.title}</h5>
          <p className="mb-0">{modalConfig.message}</p>
        </Modal.Body>
      </Modal>
      {/* <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>{modalConfig.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{modalConfig.message}</Modal.Body>
        <Modal.Footer>
          <Button
            variant={modalConfig.type === "success" ? "primary" : "secondary"}
            onClick={() => setShowModal(false)}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal> */}
    </Container>
  );
};

export default RoomManagementForm;
